import { IntlMessageFormat } from 'intl-messageformat'
import type { MessageCompiler, MessageContext } from 'vue-i18n'

/** @ts-ignore-next-line */
export const messageCompiler: MessageCompiler = (message, { locale, key }) => {
  if (typeof message === 'string') {
    const formatter = new IntlMessageFormat(message, locale)

    return (ctx: MessageContext) => {
      try {
        return formatter.format(ctx.values)
      } catch (e) {
        return message.replace(/\{(\w+)\}/g, (match, key) => (ctx.values[key] as string) || match)
      }
    }
  }

  return () => key
}
